import * as get from 'lodash/get';
import * as has from 'lodash/has';

import { EncryptedPartnerFields, OriginPlatform } from '../models';
import { ModelPortfolio } from './../models/model-portfolio';
import { Security } from './../models/security';

export class ModelPortfolioBuilder {
	private modelPortfolio: ModelPortfolio;

	constructor() {
		this.modelPortfolio = new ModelPortfolio();
	}

	public setApplications(applications: Array<string>): ModelPortfolioBuilder {
		this.modelPortfolio.applications = applications;
		return this;
	}

	public setBaseModel(baseModel: number): ModelPortfolioBuilder {
		this.modelPortfolio.baseModel = baseModel;
		return this;
	}

	// used for IQ - userPortfolios store
	public setChildCount(childCount: number): ModelPortfolioBuilder {
		this.modelPortfolio.childCount = childCount;
		return this;
	}

	public setDescription(description: string): ModelPortfolioBuilder {
		this.modelPortfolio.description = description;
		return this;
	}

	public setDesignation(designation: string): ModelPortfolioBuilder {
		this.modelPortfolio.designation = designation;
		return this;
	}

	public setNetExpenseRatio(analyticsMap: any): ModelPortfolioBuilder {
		this.modelPortfolio.netExpenseRatio = has(analyticsMap, 'prospectusNetExpenseRatio.value') ? get(analyticsMap, 'prospectusNetExpenseRatio.value') : 0;
		return this;
	}

	public setNetExpenseRatioNumber(netExpenseRatio: number): ModelPortfolioBuilder {
		this.modelPortfolio.netExpenseRatio = netExpenseRatio;
		return this;
	}

	public setNetExpenseRatioAsOfDate(asOfDate: any): ModelPortfolioBuilder {
		if (asOfDate) {
			this.modelPortfolio.netExpenseRatioAsOfDate = asOfDate;
		}
		return this;
	}

	public setFlags(flags: any): ModelPortfolioBuilder {
		this.modelPortfolio.flags = flags;
		return this;
	}

	public setOrigin(origin: string): ModelPortfolioBuilder {
		this.modelPortfolio.origin = origin;
		return this;
	}

	public setSubType(subType: string): ModelPortfolioBuilder {
		this.modelPortfolio.subType = subType;
		return this;
	}

	public setSubTypeKey(subTypeKey: string): ModelPortfolioBuilder {
		this.modelPortfolio.subTypeKey = subTypeKey;
		return this;
	}

	public setEncrypted(encrypted: EncryptedPartnerFields): ModelPortfolioBuilder {
		this.modelPortfolio.encrypted = encrypted;
		return this;
	}

	public setOriginPlatform(originPlatform: OriginPlatform): ModelPortfolioBuilder {
		this.modelPortfolio.originPlatform = originPlatform;
		return this;
	}

	public setType(type: string): ModelPortfolioBuilder {
		this.modelPortfolio.type = type;
		return this;
	}

	public setUniqueId(uniqueId: string): ModelPortfolioBuilder {
		this.modelPortfolio.uniqueId = uniqueId;
		return this;
	}

	public setParentId(parentId: string): ModelPortfolioBuilder {
		this.modelPortfolio.parentId = parentId;
		return this;
	}

	public setDateLastModified(dateLastModified: string): ModelPortfolioBuilder {
		this.modelPortfolio.dateLastModified = dateLastModified;
		return this;
	}

	public setPortfolioId(portfolioId: number): ModelPortfolioBuilder {
		this.modelPortfolio.portfolioId = portfolioId;
		return this;
	}

	public setSecurities(securities: Array<Security>): ModelPortfolioBuilder {
		this.modelPortfolio.securities = securities;
		return this;
	}

	public setYieldValue(analyticsMap: any): ModelPortfolioBuilder {
		this.modelPortfolio.yieldValue =
			analyticsMap && analyticsMap.twelveMonthTrailingYield && analyticsMap.twelveMonthTrailingYield.value ? analyticsMap.twelveMonthTrailingYield.value : 0;
		return this;
	}

	public setYieldValueNumber(yieldValue: number): ModelPortfolioBuilder {
		this.modelPortfolio.yieldValue = yieldValue;
		return this;
	}

	public setYieldAsOfDate(asOfDate: any): ModelPortfolioBuilder {
		if (asOfDate) {
			this.modelPortfolio.yieldAsOfDate = asOfDate;
		}
		return this;
	}

	public setHoldingAsOfDate(date: any): ModelPortfolioBuilder {
		if (date) {
			this.modelPortfolio.holdingAsOfDate = String(date);
		}
		return this;
	}

	public setStandardDeviation(value: number): ModelPortfolioBuilder {
		this.modelPortfolio.standardDeviation = value;
		return this;
	}

	public setStandardDeviationAsOfDate(asOfDate: any): ModelPortfolioBuilder {
		if (asOfDate) {
			this.modelPortfolio.standardDeviationAsOfDate = asOfDate;
		}
		return this;
	}

	public setIsAssetClassOnly(value: boolean): ModelPortfolioBuilder {
		this.modelPortfolio.isAssetClassOnly = value;
		return this;
	}

	public setPrevRebalancedDate(prevRebalancedDate: string): ModelPortfolioBuilder {
		if (prevRebalancedDate) {
			this.modelPortfolio.prevRebalancedDate = prevRebalancedDate.toString();
		}
		return this;
	}

	public setTags(tags: string[]): ModelPortfolioBuilder {
		this.modelPortfolio.tags = tags;
		return this;
	}

	public setACTags(tags: string[]): ModelPortfolioBuilder {
		this.modelPortfolio.acTags = tags;
		return this;
	}

	public setHoldingsError(hasHoldingsError: boolean): ModelPortfolioBuilder {
		this.modelPortfolio.hasHoldingsError = hasHoldingsError;
		return this;
	}

	public convertBfmDateToDate(asOfDate: number): Date {
		const dateStr = asOfDate.toString();
		return new Date(+dateStr.slice(0, 4), +dateStr.slice(-4, -2) - 1, +dateStr.slice(-2));
	}

	public build(): ModelPortfolio {
		return this.modelPortfolio;
	}
}
